module.exports = __webpack_public_path__ + "static/media/tables.9687282b.svg";